import React from 'react';
import Body from "../components/Body";
import ErrorBoundary from "../components/ErrorBoundary";

const Home: React.FC = () => {
  return (
    <div className="home-page">
      <ErrorBoundary>
        <Body />
      </ErrorBoundary>
    </div>
  );
};

export default Home; 